import React, { useEffect, useState } from "react";
import { Box, Text, Button, Flex, Image, Center, Spinner, Tag, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, HStack, VStack, Divider, Select, useToast, AlertDialog, AlertDialogOverlay, AlertDialogContent, AlertDialogHeader, AlertDialogBody, AlertDialogFooter, IconButton, ModalFooter, Grid } from "@chakra-ui/react";
import axiosClient from "../../../axios-client";
import { useLocation, useNavigate } from "react-router-dom";
import { MdBorderColor } from "react-icons/md";
import { PiPlusBold } from "react-icons/pi";
import { useTranslation } from "react-i18next";
import { DeleteIcon, EditIcon } from "@chakra-ui/icons";
import { FiFilter } from "react-icons/fi";
import PlayVideo from "../PlayVideo";
import { FaHistory } from "react-icons/fa";

const SerieDetails = () => {
    const [serieDetails, setSerieDetails] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalOpenVid, setIsModalOpenVid] = useState(false);
    const [mediaToShow, setMediaToShow] = useState(null);
    const [episodeId, setEpisodeId] = useState(null);
    const [episode, setEpisode] = useState();
    const [typeMedia, setTypeMedia] = useState('');

    const [selectedSeason, setSelectedSeason] = useState(1);
    const [currentEpisodes, setCurrentEpisodes] = useState([]);
    const [isLoadingEpisodes, setIsLoadingEpisodes] = useState(true);
    const location = useLocation()
    const navigate = useNavigate()
    const cancelRef = React.useRef()
    const { t } = useTranslation()
    const toast = useToast()
    const [epId, setEpId] = useState(null)
    const fetchEpisodes = (serieId, season) => {
        axiosClient
            .get(`/episodes/${serieId}/season/${season}/`)
            .then((response) => {
                setCurrentEpisodes(response.data);
                setIsLoadingEpisodes(false)

            })
            .catch((error) => {
                // console.error("Error fetching episodes:", error);
                setIsLoadingEpisodes(false)
            });
    };

    useEffect(() => {
        axiosClient
            .get(`/series/${location.state.serieId}/`)
            .then((response) => {
                setSerieDetails(response.data);
                fetchEpisodes(response.data.id, 1);
            })
            .catch((error) => {
                // console.error("Error fetching serie details:", error);
            });
    }, [location.state.serieId]);

    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [isAlertEpisodeOpen, setIsAlertEpisodeOpen] = useState(false);
    const [isEpisodeFiltersOpen, setIsEpisodeFiltersOpen] = useState(false);
    const onOpenAlert = () => {
        setIsAlertOpen(true);
    };

    const onCloseAlert = () => {
        setIsAlertOpen(false);
    };
    const onOpenEpisodeFilters = () => {
        setIsEpisodeFiltersOpen(true);
    };

    const onCloseEpisodeFilters = () => {
        setIsEpisodeFiltersOpen(false);
    };
    const onOpenAlertEpisode = () => {
        setIsAlertEpisodeOpen(true);
    };

    const onCloseAlertEpisode = () => {
        setIsAlertEpisodeOpen(false);
    };
    const openModal = (mediaUrl, mediaName) => {
        setMediaToShow(mediaUrl);
        setTypeMedia((mediaName === "Bande-annonce" || mediaName === "Vidéo" || mediaName === "Extrait") ? "video" : "image")

        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setMediaToShow(null);
    };
    const openModalVid = (id) => {
        setEpId(id)
        setIsModalOpenVid(true);
    };

    const closeModalVid = () => {
        setIsModalOpenVid(false);
    };

    if (!serieDetails) {
        return (
            <Center h="50vh" mt={10}>
                <Spinner size="xl" />
            </Center>
        );
    }

    const mediaButtons = [
        { name: 'Image paysage', url: serieDetails?.image_Hquality || serieDetails?.image },
        { name: 'Image portrait', url: serieDetails?.poster_Hquality || serieDetails?.poster },
        { name: 'Logo', url: serieDetails?.logo },
        { name: 'Bande-annonce', url: serieDetails?.trailerUrl },
        { name: 'Extrait', url: serieDetails?.excerptUrl },
    ];
    const handleDelete = (id) => {
        if (!id) return;
        axiosClient.delete(`/series/delete/${id}/`)
            .then((response) => {
                toast({
                    description: t("La serie est supprimé avec succès"),
                    status: 'success',
                    variant: 'left-accent',
                    duration: 2000,
                    isClosable: true,
                    position: 'bottom-right'
                })
                navigate('/series')
            })
            .catch((error) => {
            });
        onCloseAlert()
    }
    const handleDeleteEpisode = (id) => {
        if (!id) return;
        axiosClient.delete(`/episodes/delete/${id}/`)
            .then((response) => {
                setCurrentEpisodes((prevData) => prevData.filter((row) => row.id !== id));

                toast({
                    description: t("L'épisode est supprimé avec succès"),
                    status: 'success',
                    variant: 'left-accent',
                    duration: 2000,
                    isClosable: true,
                    position: 'bottom-right'
                })
                // navigate('/series')
            })
            .catch((error) => {
            });
        onCloseAlertEpisode()
    }

    const formatTime = (seconds) => {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const secs = seconds % 60;
        return `${hours > 0 ? `${hours}h ` : ""}${minutes > 0 ? `${minutes}m ` : ""}${secs.toFixed(3)}s`;
    };
    return (
        <Box mb={10} p={5} mt="10px" display="flex" flexDirection={"column"}>
            <Box w={"100%"} mt={3} mb={2}>
                <Text fontFamily='Plus Jakarta Display' as="cite" fontSize={{ base: "18px", md: "20px", lg: "25px" }} color="gray"><span onClick={() => navigate('/')} style={{ cursor: 'pointer' }} onMouseEnter={e => e.target.style.textDecoration = "underline"} onMouseLeave={e => e.target.style.textDecoration = "none"} >{t('Accueil')}</span>  / <span onClick={() => navigate('/series')} style={{ cursor: 'pointer' }} onMouseEnter={e => e.target.style.textDecoration = "underline"} onMouseLeave={e => e.target.style.textDecoration = "none"} >{t('Liste des séries')}</span> / <span> {t('détails de la série')}</span></Text>
            </Box>
            <Box minH="25rem" display="flex" flexDirection={{ base: "column", md: "row" }} justifyContent="center" alignItems="center" gap={8}>
                <Box display="flex" flexDirection="column" justifyContent="center" w={{ base: "100%", md: "50%" }} h="full" textAlign="left">
                    <Text fontSize="5xl" fontWeight="bold" mb={2}>
                        {serieDetails?.title}
                    </Text>
                    <Text color="gray.500" fontSize="lg" mb={5}>
                        {serieDetails?.description}
                    </Text>

                    {/* Render Subcategories as Tags */}
                    <Flex wrap="wrap" gap={2}>
                        {serieDetails?.subcategory_names?.map((subCategory, index) => (
                            <Tag key={index} colorScheme="orange">{subCategory}</Tag>
                        ))}
                    </Flex>

                    <Box w="full" h="0.1rem" my={5} bg="gray.300" />

                    <Flex justifyContent="space-between" alignItems="center" w="full">
                        <Box>
                            <Text color="orange.400">
                                Sorti le:{" "}
                                <Text as="span" color="gray.500" ml={1}>
                                    {serieDetails?.releaseDate}
                                </Text>
                            </Text>
                            <Text color="orange.400">
                                Langue:{" "}
                                <Text as="span" color="gray.500" ml={1}>
                                    {serieDetails?.language}
                                </Text>
                            </Text>
                            <Flex mt={1} wrap="wrap" gap={2}>
                                <Text color="orange.400">
                                    Disponible en :
                                </Text>
                                <Text color="gray.500">
                                    {serieDetails?.pays_names?.join(" - ") || "Tous les pays"}
                                </Text>
                            </Flex>
                        </Box>
                        <Flex gap={2}>
                            {/* <IconButton
                                size="md"
                                onClick={() => {
                                    onOpenAlert();
                                }}
                                mr="5px"
                                colorScheme="red"
                                icon={<DeleteIcon />}>
                            </IconButton> */}
                            <Button
                                onClick={() =>
                                    navigate(`/modifier-serie`, {
                                        state: {
                                            serieId: serieDetails?.id,
                                        },
                                    })
                                }
                                bg={"#fa8d51"}
                                color={"white"}
                                variant="solid"
                                size="md"
                                _hover={"none"}
                            >
                                Modifier
                            </Button>
                        </Flex>
                    </Flex>


                </Box>

                <Box w={{ base: "100%", md: "50%" }} display="flex" justifyContent="center" alignItems="center" mt={{ base: 5, md: 0 }}>
                    {(serieDetails?.image_Hquality || serieDetails?.image) && (
                        <Image
                            style={{ maxHeight: "350px" }}
                            boxSize="full"
                            objectFit="cover"
                            src={serieDetails?.image_Hquality || serieDetails?.image}
                            alt={serieDetails?.title}
                        />
                    )}
                </Box>


            </Box>


            {/* Media Buttons */}
            <Grid w="100%" templateColumns={{ base: "1fr", sm: "repeat(2, 1fr)", md: "repeat(3, 1fr)", lg: "repeat(5, 1fr)" }} gap={4} mt={8}>
                {mediaButtons.map((button, index) => (
                    <Button
                        w={'full'}
                        key={index}
                        onClick={() => openModal(button.url, button.name)}
                        isDisabled={!button.url}
                        variant={"outline"}
                        colorScheme={button.url ? "cyan" : "blue"}
                    >
                        {button.name}
                    </Button>
                ))}
            </Grid>

            <Box mt={10}>
                <Flex justify={"space-between"} align="center" my={5}>
                    <Select
                        style={{ border: '1px solid #A0AEC0' }}
                        width="15rem"
                        value={selectedSeason}
                        onChange={(e) => {
                            setSelectedSeason(e.target.value);
                            fetchEpisodes(serieDetails?.id, e.target.value);
                        }}
                    >
                        {Array.from(
                            { length: serieDetails?.totalSeasons },
                            (_, index) => (
                                <option
                                    key={index + 1}
                                    value={index + 1}
                                >{`Saison ${index + 1}`}</option>
                            )
                        )}
                    </Select>
                    <Button
                        onClick={() => navigate(`/ajouter-episode`, {
                            state: {
                                idSerie: serieDetails?.id
                            }
                        })}
                        leftIcon={<PiPlusBold />} color={"white"} bgGradient='linear(to-r, #eb6921, #fa8d51)' _hover={{ bgGradient: 'linear(to-r, #eb6921,#eb6921)' }} variant='solid'>
                        {t("Ajouter un episode")}
                    </Button>
                </Flex>


                <VStack spacing={4} mt={8} align="stretch">
                    {!isLoadingEpisodes ? (
                        currentEpisodes?.length > 0 ? (
                            currentEpisodes.map((episode) => (
                                <Flex

                                    key={episode.id}
                                    align="stretch"
                                    position={"relative"}
                                    bg="#ffffffd4"
                                    _dark={{ bg: "gray.800" }}
                                    borderRadius="md"
                                    shadow="lg"
                                    mb={4}
                                    transition="transform 0.3s"
                                    _hover={{ transform: "scale(1.02)" }}
                                    cursor={"pointer"}
                                    onClick={() => {
                                        openModalVid()
                                        setEpId(episode?.id)
                                    }}
                                >
                                  

                                    <Flex
                                    py={0}
                                        display={{ base: "none", lg: "block" }}
                                        flexShrink={0}
                                        cursor="pointer"
                                        height={"auto"}
                                        mr={4}
                                    >
                                        <Image
                                            src={serieDetails.image}
                                            alt={`Episode ${episode.episodeNumber} Thumbnail`}
                                            w="180px"
                                            h="100%"
                                            objectFit="cover"
                                            borderRadius="md"

                                        />
                                    </Flex>
                                    <VStack w={"100%"} px={5}
                                        py={4} align="start" spacing={2}>
                                        <Flex w={"100%"} justify={"space-between"}>
                                          
                                            <Text
                                                fontSize="xl"
                                                fontWeight="medium"
                                                color="gray.800"
                                                _dark={{ color: "white" }}
                                            >
                                                {`Episode ${episode.episodeNumber}: ${episode.title}`}
                                            </Text>
                                            <Flex 
                                                
                                                bg="transparent"
                                                _hover={"none"}
                                                
                                                mr="5px"
                                                gap={0}>
                                                <IconButton
                                                    bg="transparent"
                                                    _hover={"none"}
                                                    size="md"
                                                    color="green.500"
                                                    onClick={(e) => {
                                                        e.stopPropagation()
                                                        navigate(`/historique_episode`, {
                                                            state: {
                                                                episodeId: episode?.id,
                                                            },
                                                        })
                                                    }}
                                                    icon={<FaHistory />}>
                                                </IconButton>
                                                <IconButton
                                                    bg="transparent"
                                                    _hover={"none"}
                                                    size="md"
                                                    color="blue.600"
                                                    onClick={(e) => {
                                                        e.stopPropagation()
                                                        onOpenEpisodeFilters();
                                                        setEpisode(episode)
                                                    }}
                                                    icon={<FiFilter />}>
                                                </IconButton>
                                                <IconButton
                                                    bg="transparent"
                                                    _hover={"none"}
                                                    size="md"
                                                    color="orange"
                                                    onClick={(e) => {
                                                        e.stopPropagation()
                                                        navigate(`/modifier-episode`, {
                                                            state: {
                                                                idEpisode: episode?.id,
                                                                idSerie: serieDetails?.id
                                                            },
                                                        })

                                                    }}
                                                    icon={<EditIcon />}>
                                                </IconButton>
                                                <IconButton

                                                    bg="transparent"
                                                    _hover={"none"}
                                                    size="md"
                                                    color="red"
                                                    onClick={(e) => {
                                                        e.stopPropagation()
                                                        onOpenAlertEpisode();
                                                        setEpisodeId(episode.id)
                                                    }}

                                                    icon={<DeleteIcon />}>
                                                </IconButton>
                                            </Flex>
                                        </Flex>

                                        <Text fontSize="md" color="teal.500">
                                            {episode.duration < 60
                                                ? `${episode.duration} secs`
                                                : episode.duration < 3600
                                                    ? `${Math.floor(episode.duration / 60)} min${Math.floor(episode.duration / 60) > 1 ? "s" : ""} ${episode.duration % 60 > 0 ? `${episode.duration % 60} secs` : ""
                                                    }`
                                                    : `${Math.floor(episode.duration / 3600)} hr${Math.floor(episode.duration / 3600) > 1 ? "s" : ""} ${Math.floor((episode.duration % 3600) / 60) > 0
                                                        ? `${Math.floor((episode.duration % 3600) / 60)} min${Math.floor((episode.duration % 3600) / 60) > 1 ? "s" : ""}`
                                                        : ""
                                                    } ${episode.duration % 60 > 0 ? `${episode.duration % 60} secs` : ""}`}
                                        </Text>
                                        <Text
                                            fontSize="sm"
                                            color="gray.600"
                                            _dark={{ color: "gray.300" }}
                                        >
                                            {episode.description}
                                        </Text>
                                    </VStack>
                                </Flex>
                            ))
                        ) : (
                            <HStack justify="center" mt={10}>
                                <Text>Il n'y a pas d'épisodes...</Text>
                            </HStack>
                        )
                    ) : (
                        <HStack justify="center" mt={10}>
                            <Spinner size="lg" />
                            <Text>Chargement des épisodes...</Text>
                        </HStack>
                    )}

                </VStack>
            </Box>
            {/* Modal to Show Media */}
            <Modal bg={'transparent'} size={"2xl"} isOpen={isModalOpen} onClose={closeModal}>
                <ModalOverlay bg={'blackAlpha.700'} backdropFilter='auto'
                />
                <ModalContent bg={'transparent'} shadow={"none"}>
                    {/* <ModalHeader>Media Display</ModalHeader> */}
                    {/* <ModalCloseButton /> */}
                    <ModalBody>
                        {typeMedia === "video" ? (
                            <video controls src={mediaToShow} style={{ width: '100%', height: 'auto' }} />
                        ) : (
                            <Image src={mediaToShow} alt="Media" boxSize="full" objectFit="contain" />
                        )}
                    </ModalBody>
                </ModalContent>
            </Modal>
            <Modal bg={'transparent'} size={"5xl"} isOpen={isModalOpenVid} onClose={closeModalVid}>
                <ModalOverlay bg={'blackAlpha.700'} backdropFilter='auto'
                />
                <ModalContent bg={'transparent'} shadow={"none"}>
                    {/* <ModalHeader>Media Display</ModalHeader> */}
                    {/* <ModalCloseButton /> */}
                    <ModalBody>
                        <PlayVideo id={epId} type={"episode"} />
                    </ModalBody>
                </ModalContent>
            </Modal>
            <Modal bg={'transparent'} size={"lg"} isOpen={isEpisodeFiltersOpen} onClose={onCloseEpisodeFilters}>
                <ModalOverlay
                />
                <ModalContent >
                    <ModalHeader>Filtres par section </ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        {episode?.filter_chunks?.length > 0 ?
                            episode?.filter_chunks.map((chunk, index) => (
                                <HStack w={"100%"} mr={5} color="gray.700" key={index} spacing={3} justify="start">
                                    <Text>{chunk.start ? "De " + formatTime(chunk.start) : "Début (sec)"}</Text>
                                    <Text>{chunk.end ? "à " + formatTime(chunk.end) : "Fin (sec)"}</Text>
                                    <Text>{" : " + chunk.label.toLowerCase() || "Étiquette"}</Text>
                                </HStack>
                            )) :
                            <Text color={'gray.500'}>Aucun filtre disponible</Text>}
                    </ModalBody>
                    <ModalFooter></ModalFooter>
                </ModalContent>
            </Modal>
            <AlertDialog
                isOpen={isAlertOpen}
                leastDestructiveRef={cancelRef}
                onClose={onCloseAlert}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                            {t("Supprimer la série")}
                        </AlertDialogHeader>

                        <AlertDialogBody>
                            {t("êtes-vous sûr ? Vous ne pourrez pas annuler cette action ultérieurement.")}
                        </AlertDialogBody>

                        <AlertDialogFooter>
                            <Button ref={cancelRef} onClick={onCloseAlert}>
                                {t("Annuler")}
                            </Button>
                            <Button onClick={() => handleDelete(serieDetails?.id)} colorScheme='red' ml={3}>
                                {t("Supprimer")}
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>
            <AlertDialog
                isOpen={isAlertEpisodeOpen}
                leastDestructiveRef={cancelRef}
                onClose={onCloseAlertEpisode}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                            {t("Supprimer l'épisode")}
                        </AlertDialogHeader>

                        <AlertDialogBody>
                            {t("êtes-vous sûr ? Vous ne pourrez pas annuler cette action ultérieurement.")}
                        </AlertDialogBody>

                        <AlertDialogFooter>
                            <Button ref={cancelRef} onClick={onCloseAlertEpisode}>
                                {t("Annuler")}
                            </Button>
                            <Button onClick={() => handleDeleteEpisode(episodeId)} colorScheme='red' ml={3}>
                                {t("Supprimer")}
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>
        </Box>

    );
};

export default SerieDetails;
